import { useQuery } from '@tanstack/react-query';
import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { companyService } from 'services';

const List = () => {
 const [consult, setConsult] = useState({ text: '', status: false });

 const { data } = useQuery({
  queryKey: ['companyList'],
  queryFn: () => companyService.consultCompanyByNit(consult.text),
  enabled: consult.status,
  onSuccess: () => setConsult({ ...consult, status: false })
 });

 return (
  <div className="container">
   <Button className="mt-3" onClick={() => setConsult({ ...consult, status: !consult.status })}>
    Consulta
   </Button>
   <Form.Control
    className="mt-3 mb-3"
    onChange={e => setConsult({ ...consult, text: e.target.value })}
    placeholder="nit"
   ></Form.Control>
   {data && (
    <div>
     <p>Nit: {data.nit}</p>
     <p>Name: {data.name}</p>
     <p>City: {data.city}</p>
     <p>Matricula: {data.matricula}</p>
     <p>Estado: {data.estado}</p>
     <p>Sociedad: {data.sociedad}</p>
     <p>Organizacion: {data.organizacion}</p>
     <p>Categoria: {data.categoria}</p>
     <p>Actualizado: {data.actualizado}</p>
     <p>Actividades:</p>
     <ul>
      {data.actividades.map((item, index) => (
       <li key={index}>{item}</li>
      ))}
     </ul>
    </div>
   )}
  </div>
 );
};

export default List;
